"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gmailListLabels = exports.gmailListLabelsResultSchema = exports.gmailListLabelsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.gmailListLabelsArgsSchema = (0, common_1.PipedreamNodeArgsSchema)('list-labels', zod_1.z.object({}) // No input required
);
var gmailListLabelsLabelSchema = zod_1.z.object({
    id: zod_1.z.string().describe('The immutable ID of the label'),
    name: zod_1.z.string().describe('The display name of the label'),
});
exports.gmailListLabelsResultSchema = (0, common_1.PipedreamNodeResultSchema)(zod_1.z.array(gmailListLabelsLabelSchema));
exports.gmailListLabels = (0, common_1.createToolMetadata)({
    id: 'gmailListLabels',
    displayName: 'Gmail List Labels',
    displayDescription: 'List all labels in the Gmail mailbox',
    category: 'communication',
    color: common_1.BRAND_COLORS.GMAIL,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GMAIL),
    icon: 'gmail',
    argsSchema: exports.gmailListLabelsArgsSchema,
}, exports.gmailListLabelsResultSchema);
